import { fetchBranchDetailsData, updateEwayBillForBranch } from '_services/accountsServices/branchServices';
import { CommonInput } from 'components'
import { UserContext } from 'context';
import { errorSchema, utils } from 'helper';
import React, { useContext, useEffect, useState } from 'react'
import toast from 'react-hot-toast';
import ReactPlayer from 'react-player'
import { useParams } from 'react-router-dom';
import StorageService from 'utils/StorageServices';

const EwayBillIntegration = ({ onDataFetch }) => {

    let { id } = useParams();
    const [gstDisabled, setGstDisabled] = useState(false)
    const [branchSettingPermi, setBranchSettingPermi] = useState({})
    console.log("branchSettingPermi", branchSettingPermi);
    const hours24 = Array.from({ length: 24 }, (_, i) =>
        i.toString().padStart(2, "0") + ":00"
    );

    const timeLabel = (time) =>
        new Date(`1970-01-01T${time}:00Z`).toLocaleTimeString("en-US", {
            hour: "numeric",
            hour12: true,
            timeZone: "UTC"
        });

    const initialObject = {
        "company_id": "",
        "branch_id": "",
        "eway_bill_integration": {
            "gstin": "",
            "userid": "",
            "password": ""
        },
        "eway_bill_auto_renewal": {
            "enabled": false,
            "attempts": [
                { "enabled": false, "time": "" },
                { "enabled": false, "time": "" },
                { "enabled": false, "time": "" }
            ]
        },
        "sim_based_tracking": {
            "sim_tracking_enabled": 0,
            "tracking_times": []
        }
    }

    const status = [
        { title: "Available", value: "available" },
        { title: "Not Available", value: "not_available" },
        { title: "premium", value: "premium" },
        { title: "Coming soon", value: "coming_soon" }

    ]
    const { masterData } = useContext(UserContext)
    const [form, setForm] = useState(initialObject);
    const [formError, setFormError] = useState('');
    const [detailsData, setDetailsData] = useState({})
    const companyId = StorageService.getCompanyId();
    const [loading, setLoading] = useState(false);
    const [isLoadingGst, setIsLoadingGst] = useState(false);
    const [isLoadingTime, setIsLoadingTime] = useState(false);
    const [showPermision, setShowPermision] = useState({

    })

    console.log("showPermision", showPermision);

    useEffect(() => {
        if (id) {
            setLoading(true);
            getDataBranchDetails(id, companyId);
            setForm((prev) => ({
                ...prev,
                company_id: companyId,
                branch_id: id,

            }));
        }
    }, [id, masterData])

    useEffect(() => {
        const permissions = branchSettingPermi?.permissions;
        if (!permissions?.length) return;

        const getPermission = (name) => {
            const found = permissions.find((p) => p?.name === name);
            return found ? { ...found, status: getStatusTitle(found) } : { status: "Not Available" };
        };

        setShowPermision((prev) => ({
            ...prev,
            Eway_Bill_Integration: getPermission("Eway Bill Integration"),
            Eway_Bill_Auto_Renewal: getPermission("Eway Bill Auto Renewal"),
            SIM_Based_Tracking: getPermission("SIM Based Tracking"),
        }));
    }, [branchSettingPermi]);

    const getStatusTitle = (item) => {
        const statusItem = status.find((st) => item[st.value] === 1);
        return statusItem ? statusItem.title : "";
    };

    const getStatusColor = (status) => {
        switch (status) {
            case "Available":
                return "success";
            case "Not Available":
                return "danger";
            case "Premium":
                return "warning";
            case "Coming Soon":
                return "info";
            default:
                return "secondary";
        }
    };


    const getDataBranchDetails = async (id_1, id_2) => {
        try {
            const object = {
                branch_id: id_1,
                company_id: id_2,
            };
            const res = await fetchBranchDetailsData(object);

            if (res?.responseCode === 200) {
                const apiData = res?.data?.branch;
                // setDetailsData(apiData);
                setForm((prev) => ({
                    ...prev,
                    eway_bill_integration: {
                        ...prev.eway_bill_integration,
                        gstin: apiData?.eway_bill_integration?.gstin || "",
                        userid: apiData?.eway_bill_integration?.userid || "",
                        password: apiData?.eway_bill_integration?.password || "",
                    },

                    sim_based_tracking: {
                        ...prev.sim_based_tracking,
                        sim_tracking_enabled: apiData?.sim_based_tracking?.sim_tracking_enabled || "",
                        tracking_times: apiData?.sim_based_tracking?.tracking_times || []
                    }

                }))
                const findBranchSetting = apiData?.company_id?.subscription_data?.company_settings?.find((i) => i?.sort == 4)
                setBranchSettingPermi(findBranchSetting)
                if (apiData?.eway_bill_integration?.gstin) {
                    setGstDisabled(true)
                }
                onDataFetch(apiData);
            }
        } catch (error) {
            // handle error
        } finally {
            setLoading(false);
        }
    };

    const handleEwayIntegrationChange = async (field, value) => {
        // Prepare updated form object
        const updatedForm = {
            ...form,
            eway_bill_integration: {
                ...form.eway_bill_integration,
                [field]: value
            }
        };

        // Update form state
        setForm(updatedForm);

        // Validate only if there's an existing error (user is correcting)
        if (!!formError) {
            const validationResult = await utils.checkFormError(
                updatedForm.eway_bill_integration,
                errorSchema.ewayIntegrationSchema
            );

            if (validationResult === true) {
                setFormError(""); // Clear all errors (or refine to just clear specific)
            } else {
                setFormError(validationResult); // Set updated errors
            }
        }
    };


    const handleEwayToggle = (isEnabled) => {
        const updatedAttempts = form.eway_bill_auto_renewal.attempts.map((attempt) => ({
            ...attempt,
            enabled: isEnabled ? attempt.enabled : false,
            time: isEnabled ? attempt.time : "" // clear if toggled off
        }));

        setForm((prev) => ({
            ...prev,
            eway_bill_auto_renewal: {
                ...prev.eway_bill_auto_renewal,
                enabled: isEnabled,
                attempts: updatedAttempts,
            },
        }));
    };


    const handleAttemptToggle = (index, isChecked) => {
        const updatedAttempts = [...form.eway_bill_auto_renewal.attempts];

        updatedAttempts[index] = {
            ...updatedAttempts[index],
            enabled: isChecked,
            time: isChecked ? updatedAttempts[index].time : "", // clear time if unchecked
        };

        setForm((prev) => ({
            ...prev,
            eway_bill_auto_renewal: {
                ...prev.eway_bill_auto_renewal,
                attempts: updatedAttempts,
            },
        }));
    };

    const handleAttemptTimeChange = (index, time) => {
        const updatedAttempts = [...form.eway_bill_auto_renewal.attempts];
        updatedAttempts[index].time = time;
        setForm((prev) => ({
            ...prev,
            eway_bill_auto_renewal: {
                ...prev.eway_bill_auto_renewal,
                attempts: updatedAttempts
            }
        }));
    };

    // 🔄 Handlers for SIM Tracking
    const handleSimTrackingToggle = (enabled) => {
        setForm((prev) => ({
            ...prev,
            sim_based_tracking: {
                ...prev.sim_based_tracking,
                sim_tracking_enabled: enabled ? 1 : 0,
                tracking_times: enabled ? prev.sim_based_tracking.tracking_times : [], // clear if disabled
            },
        }));
    };

    const handleSimHourToggle = (hour) => {
        const current = form.sim_based_tracking.tracking_times;
        const updated = current.includes(hour)
            ? current.filter((t) => t !== hour)
            : [...current, hour];
        setForm((prev) => ({
            ...prev,
            sim_based_tracking: {
                ...prev.sim_based_tracking,
                tracking_times: updated
            }
        }));
    };


    const submitEwayIntrigation = async () => {
        const validationResult = await utils?.checkFormError(
            form?.eway_bill_integration,
            errorSchema.ewayIntegrationSchema
        );


        if (form?.sim_based_tracking?.sim_tracking_enabled) {
            if (!form?.sim_based_tracking?.tracking_times?.length) {
                toast((t) => (
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "5px", fontSize: "14px" }}><span >
                        Please select at least <b>one</b> tracking time.
                    </span>
                        <button onClick={() => toast.dismiss(t.id)} style={{ border: "1px solid #dddd", padding: "5px", borderRadius: "5px", background: "#dddd", fontSize: "14px" }}>
                            Close
                        </button></div>
                ));
                return;
            }
        }


        if (form?.eway_bill_auto_renewal?.enabled) {
            const invalidAttempts = form?.eway_bill_auto_renewal?.attempts?.some(attempt => attempt?.enabled !== true);
            if (invalidAttempts) {

                toast((t) => (
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "5px", fontSize: "14px" }}><span >
                        Please enable at least <b>one</b> attempt.
                    </span>
                        <button onClick={() => toast.dismiss(t.id)} style={{ border: "1px solid #dddd", padding: "5px", borderRadius: "5px", background: "#dddd", fontSize: "14px" }}>
                            Close
                        </button></div>
                ));
                return;
            }
        }


        if (validationResult !== true) {
            setFormError(validationResult);
            return;
        }

        setIsLoadingGst(true);

        try {
            const res = await updateEwayBillForBranch({ ...form });

            if (res?.responseCode === 200) {
                getDataBranchDetails(id, companyId);
                toast.success(res?.responseMessage || "Eway Bill Integration Updated Successfully");

            } else {
                toast.error(res?.responseMessage || "Something went wrong.");
            }
        } catch (err) {
            toast.error("Submission failed. Please try again.");
        } finally {
            setIsLoadingGst(false);
        }
    };


    const submitEwayTime = async () => {

        if (form?.sim_based_tracking?.sim_tracking_enabled) {
            const times = form?.sim_based_tracking?.tracking_times;

            if (!Array.isArray(times) || times.length === 0) {

                toast((t) => (
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "5px", fontSize: "14px" }}><span >
                        Please select at least <b>one</b> tracking time.
                    </span>
                        <button onClick={() => toast.dismiss(t.id)} style={{ border: "1px solid #dddd", padding: "5px", borderRadius: "5px", background: "#dddd", fontSize: "14px" }}>
                            Close
                        </button></div>
                ));

                return;
            }
        }


        setIsLoadingTime(true);
        try {
            const res = await updateEwayBillForBranch({ ...form });
            if (res?.responseCode === 200) {
                getDataBranchDetails(id, companyId);
                toast.success(res?.responseMessage || "Eway Bill Time Updated Successfully");
            } else {
                toast.error(res?.responseMessage || "Update failed.");
            }
        } catch (error) {
            toast.error("Something went wrong.");
        } finally {
            setIsLoadingTime(false);
        }
    };



    return (
        <>
            <div className='__setBr_main'>
                <div className='__setf_brancOtr'>
                    <div className='__setf_brancInner'>
                        {/* Box 1 */}
                        <div className='__setf_brancBx'>
                            {showPermision.Eway_Bill_Integration?.status!="Not Available" && <div className='__setf_brHead'>
                                <h4>Eway Bill Integration {showPermision.Eway_Bill_Integration?.status!="Available" && <span
                                    className={`badge bg-${getStatusColor(showPermision.Eway_Bill_Integration?.status)}`}
                                    style={{
                                        marginLeft: "10px",
                                        padding: "5px 10px",
                                        borderRadius: "12px",
                                        fontSize: "12px",
                                        fontWeight: "500",
                                        textTransform: "uppercase",
                                    }}
                                >
                                    {showPermision.Eway_Bill_Integration?.status}
                                </span>}</h4>
                            </div>}
                            {showPermision.Eway_Bill_Integration?.web == 1 && <div className='__setf_branc_sepBx __integretBillBx'>
                                <div className='__ewb_int_left'>
                                    <CommonInput
                                        type="text"
                                        placeholder="GSTIN"
                                        label="GSTIN"
                                        value={form.eway_bill_integration.gstin}
                                        onChange={(e) => {
                                            const upperValue = e.target.value.toUpperCase();
                                            handleEwayIntegrationChange("gstin", upperValue)
                                        }}
                                        disabled={gstDisabled}
                                        error={formError?.gstin}
                                        errorShow={formError?.gstin ? true : false}
                                        maxLength={40}
                                    />

                                    <CommonInput
                                        type="text"
                                        placeholder="User ID"
                                        label="User ID"
                                        value={form.eway_bill_integration.userid}
                                        onChange={(e) => handleEwayIntegrationChange("userid", e.target.value)}
                                        error={formError?.userid}
                                        errorShow={formError?.userid ? true : false}
                                        maxLength={40}
                                    />

                                    <CommonInput
                                        type="text"
                                        placeholder="Password"
                                        label="Password"
                                        value={form.eway_bill_integration.password}
                                        onChange={(e) =>
                                            handleEwayIntegrationChange("password", e.target.value)
                                        }
                                        error={formError?.password}
                                        errorShow={formError?.password ? true : false}
                                        maxLength={40}
                                    />
                                </div>

                                <div className='__ewb_int_right'>
                                    <div className="player-wrapper" style={{ width: '100%', maxWidth: '413px', height: '245.42px', borderRadius: '8px', overflow: 'hidden' }}>
                                        <ReactPlayer
                                            url="https://www.youtube.com/watch?v=D0UnqGm_miA"
                                            className="react-player"
                                            playing={false}
                                            controls={true}
                                            width="100%"
                                            height="100%"
                                        />
                                    </div>
                                </div>
                            </div>}
                            {showPermision.Eway_Bill_Integration?.web == 1 && <div className='__setf_branc_btnBx'>
                                <button onClick={submitEwayIntrigation} disabled={isLoadingGst}>{isLoadingGst ? "Updating..." : "Update"}</button>
                            </div>}
                        </div>
                        {/* Box 1 */}

                        {/* Box 2 */}
                        {showPermision.Eway_Bill_Auto_Renewal?.status!="Not Available" &&<div className='__setf_brancBx'>
                            <div className='__setf_brHead'>
                                <h4>Eway Bill Auto Renewal {showPermision.Eway_Bill_Auto_Renewal?.status!="Available" &&<span
                                    className={`badge bg-${getStatusColor(showPermision.Eway_Bill_Auto_Renewal?.status)}`}
                                    style={{
                                        marginLeft: "10px",
                                        padding: "5px 10px",
                                        borderRadius: "12px",
                                        fontSize: "12px",
                                        fontWeight: "500",
                                        textTransform: "uppercase",
                                    }}
                                >
                                    {showPermision.Eway_Bill_Auto_Renewal?.status}
                                </span>}</h4>
                            </div>
                            {showPermision.Eway_Bill_Auto_Renewal?.web == 1 && <div className='__setf_branc_sepBx __integretBillBx'>
                                <h4>Eway Bill Auto Renewal </h4>

                                <div className="_flxOtr">

                                    <div className="_dualCheckr_bx">
                                        <input
                                            className="form-check-input"
                                            id="eway_bill_auto_renewal_yes1"
                                            type="radio"
                                            name="Supplier_PAN"
                                            checked={form.eway_bill_auto_renewal.enabled}
                                            onChange={() => handleEwayToggle(true)}

                                        />
                                        <label
                                            htmlFor="eway_bill_auto_renewal_yes1"
                                            className="form-check-label"
                                        >
                                            Yes
                                        </label>
                                    </div>

                                    <div className="_dualCheckr_bx">
                                        <input
                                            className="form-check-input"
                                            id="eway_bill_auto_renewal_no1"
                                            type="radio"
                                            name="Supplier_PAN"
                                            checked={!form.eway_bill_auto_renewal.enabled}
                                            onChange={() => handleEwayToggle(false)}
                                        />
                                        <label
                                            htmlFor="eway_bill_auto_renewal_no1"
                                            className="form-check-label"
                                        >
                                            No
                                        </label>
                                    </div>
                                </div>
                                {form.eway_bill_auto_renewal.enabled && <>
                                    {form.eway_bill_auto_renewal.attempts.map((attempt, idx) => (<div className='__setCheker __timeTrak_chk'>
                                        <div className="__setCheker_inn" key={idx}>
                                            <input
                                                type="checkbox"
                                                label="Dashboard"
                                                id={`attempt_checkbox_${idx}`}
                                                checked={attempt.enabled}
                                                onChange={(e) => handleAttemptToggle(idx, e.target.checked)}
                                                disabled={!form.eway_bill_auto_renewal.enabled}
                                            />
                                            <label
                                                htmlFor={`attempt_checkbox_${idx}`}
                                                className="anvLabel"
                                            >
                                                {`${idx + 1}st Attempt`}
                                            </label>
                                        </div>
                                        <div className='__ewTimeBx'>
                                            <input type="time"
                                                value={attempt.time}
                                                disabled={!attempt.enabled}
                                                onChange={(e) => handleAttemptTimeChange(idx, e.target.value)}
                                            />
                                        </div>
                                    </div>))}
                                </>}


                            </div>}
                            {showPermision.Eway_Bill_Auto_Renewal?.web == 1 && <div className='__setf_branc_btnBx'>
                                <button>Update</button>
                            </div>}
                        </div>}
                        {/* Box 2 */}

                        {/* Box 3 */}
                       {showPermision.SIM_Based_Tracking?.status!="Not Available" && <div className='__setf_brancBx'>
                            <div className='__setf_brHead'>
                                <h4>SIM Based Tracking {showPermision.SIM_Based_Tracking?.status!="Available" &&<span
                                    className={`badge bg-${getStatusColor(showPermision.SIM_Based_Tracking?.status)}`}
                                    style={{
                                        marginLeft: "10px",
                                        padding: "5px 10px",
                                        borderRadius: "12px",
                                        fontSize: "12px",
                                        fontWeight: "500",
                                        textTransform: "uppercase",
                                    }}
                                >
                                    {showPermision.SIM_Based_Tracking?.status}
                                </span>}</h4>
                            </div>
                            {showPermision.SIM_Based_Tracking?.web == 1 && <div className='__setf_branc_sepBx'>
                                <h4>SIM Based Tracking </h4>

                                <div className="_flxOtr">

                                    <div className="_dualCheckr_bx">
                                        <input
                                            className="form-check-input"
                                            id="sim_based_tracking_yes1"
                                            type="radio"
                                            name="sim_based_tracking"
                                            checked={form.sim_based_tracking.sim_tracking_enabled == 1}
                                            onChange={() => handleSimTrackingToggle(true)}
                                        />
                                        <label
                                            htmlFor="sim_based_tracking_yes1"
                                            className="form-check-label"
                                        >
                                            Yes
                                        </label>
                                    </div>

                                    <div className="_dualCheckr_bx">
                                        <input
                                            className="form-check-input"
                                            id="sim_based_tracking_no1"
                                            type="radio"
                                            name="sim_based_tracking"
                                            checked={form.sim_based_tracking.sim_tracking_enabled == 0}
                                            onChange={() => handleSimTrackingToggle(false)}
                                        />
                                        <label
                                            htmlFor="sim_based_tracking_no1"
                                            className="form-check-label"
                                        >
                                            No
                                        </label>
                                    </div>
                                </div>

                                {form.sim_based_tracking.sim_tracking_enabled == 1 && <div className='__setCheker __timeTrak_chk'>
                                    {hours24.slice(0, 12).map((hour) => (<div className="__setCheker_inn" key={hour}>
                                        <input
                                            type="checkbox"
                                            label="Dashboard"
                                            id={`sim_tracking_checkbox_${hour}`}
                                            disabled={form.sim_based_tracking.sim_tracking_enabled === 0}
                                            checked={form.sim_based_tracking.tracking_times.includes(hour)}
                                            onChange={() => handleSimHourToggle(hour)}
                                        />
                                        <label
                                            htmlFor={`sim_tracking_checkbox_${hour}`}
                                            className="anvLabel"
                                        >
                                            {timeLabel(hour)}
                                        </label>
                                    </div>))}


                                </div>}

                                {form.sim_based_tracking.sim_tracking_enabled == 1 && <div className='__setCheker __timeTrak_chk'>
                                    {hours24.slice(12, 24).map((hour) => (<div className="__setCheker_inn" key={hour}>
                                        <input
                                            type="checkbox"
                                            label="Dashboard"
                                            id={`sim_tracking_checkbox_${hour}`}
                                            disabled={form.sim_based_tracking.sim_tracking_enabled === 0}
                                            checked={form.sim_based_tracking.tracking_times.includes(hour)}
                                            onChange={() => handleSimHourToggle(hour)}
                                        />
                                        <label
                                            htmlFor={`sim_tracking_checkbox_${hour}`}
                                            className="anvLabel"
                                        >
                                            {timeLabel(hour)}
                                        </label>
                                    </div>))}


                                </div>}
                            </div>}
                            {showPermision.SIM_Based_Tracking?.web == 1 && <div className='__setf_branc_btnBx'>
                                <button onClick={submitEwayTime} disabled={isLoadingTime}>{isLoadingTime ? "Updating..." : "Update"}</button>
                            </div>}
                        </div>}
                        {/* Box 3 */}
                    </div>
                </div>
            </div>
        </>
    )
}

export default EwayBillIntegration